import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    items: [],
    isLoading: false,
    firms: []
  },
  getters: {
    items: state => state.items,
    firms: state => state.firms,
    isLoading: state => state.isLoading
  },
  mutations: {
    setItems (state, payload) {
      state.items = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setFirms (state, payload) {
      state.firms = payload
    }
  },
  actions: {
    async getItems ({ commit }) {
      commit('toggleLoading')
      const response = await new ApiService(`financial_reports`).getResults()
      commit('toggleLoading')
      commit('setItems', response)
    },
    async fetchFirms ({ commit }) {
      let params = { pagination: false, isContractor: 1 }
      const response = await new ApiService('user_datas/list', params).getResults()
      commit('setFirms', response.items)
    }
  }
}
